export default {
  ccc: 'CCC',
  pharmacist: 'PHARMACIST',
  pharmTech: 'PHARM_TECH',
  billingUser: 'BILLING_USER',
  admin: 'SYS_ADMIN',
  pharmacyProdTech: 'PHARM_PROD_TECH',
  shippingUser: 'SHIPPING_USER',
  inventoryAdmin: 'INVENTORY_ADMIN',
  inventoryManager: 'INVENTORY_MANAGER',
  inventoryViewer: 'INVENTORY_VIEWER',
  invoiceAdmin: 'INVOICE_ADMIN',
};
